export function currentUrl(domain: string, pathname: string): string {
    const [pathnameSplit] = pathname.split('?');
    const cleanedPath = (pathnameSplit || '').replace(/\/$/, '');
    return `https://${domain}${cleanedPath.toLowerCase()}`;
}
